import "bootstrap/dist/css/bootstrap.min.css";
import "./ContactUs.css";
import { useNavigate } from "react-router-dom";
export default function ContactForm() {
  const socialLinks = [
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/vr-global-consulting/",
      icon: "bi-linkedin",
    },
    {
      label: "WhatsApp",
      href: "https://api.whatsapp.com/send?phone=919963553332",
      icon: "bi-whatsapp",
    },
    {
      label: "Email",
      href: "mailto:pola@vrglobalconsulting.com",
      icon: "bi-envelope",
    },
    {
      label: "Call",
      href: "tel:+919963553332",
      icon: "bi-telephone",
    },
  ];
  const navigate = useNavigate();

  const handleOpenMaps = () => {
    window.open("https://maps.app.goo.gl/1mhimK1qMqshEMVQ8");
  };

  const handleFooterNavigation = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  };

  return (
    <div className="footer-shell text-light">
      <p className="footer-connect-title pt-4">Connect With Us</p>
      <div className="container ">
        <div className="footer-social-band">
          <div>
            <p className="footer-social-kicker">Stay Connected</p>
            <h2 className="footer-social-title">
              Follow and reach VR Global Consulting
            </h2>
          </div>
          <div className="footer-social-links" aria-label="Footer social links">
            {socialLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target={item.href.startsWith("http") ? "_blank" : undefined}
                rel={
                  item.href.startsWith("http")
                    ? "noopener noreferrer"
                    : undefined
                }
                className="footer-social-link"
                aria-label={item.label}
              >
                <span className="footer-social-icon">
                  <i className={`bi ${item.icon}`}></i>
                </span>
                <span>{item.label}</span>
              </a>
            ))}
          </div>
        </div>
        <div className="row contactFormContainer">
          <div className="col-md-6 ourDetails">
            <div className="contactDetails">
              <p className="h2 pb-1">Contact</p>
              <p>Phone +91 9963553332</p>
              <p>
                Email: <span> </span>
                <a href="mailto:pola@vrglobalconsulting.com">
                  pola@vrglobalconsulting.com
                </a>{" "}
              </p>
            </div>
            <div className="locationDetails">
              <p className="h2 pb-1">Location</p>
              <address>
                <p>Registered office: #66C, Vengal Rao Nagar </p>
                <p>Hyderabad 500038, Telangana, India</p>
                <button
                  className="btn m-0 mt-2 btn-light"
                  onClick={handleOpenMaps}
                >
                  Open in Google Maps
                </button>
              </address>
            </div>
          </div>
          <div className="col-md-6 text-center footerCtaPanel">
            <h3 className="title1 h4" style={{ color: "white" }}>
              Book A Call
            </h3>
            <p className="footer-cta-copy">
              Share your requirements with our team and get expert guidance.
            </p>
            <button
              className="btn footer-book-call-btn"
              onClick={() => handleFooterNavigation("/Contact")}
            >
              Book A Call
            </button>
          </div>
        </div>
        {/* Links Section: now outside and below the main row, full width */}
        <div className="mt-4 links-container row g-4">
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h1 className="h5 pb-2">Quick Links</h1>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/About-us">About us</a>
              </li>
              <li>
                <a href="/">Our clients</a>
              </li>
              <li>
                <a href="/About-us">Our team</a>
              </li>
              <li>
                <a href="/what-is-the-actual-process-of-getting-an-iso-certification">
                  ISO Blog
                </a>
              </li>
              <li>
                <a href="/ShowCase">ISO Consultants</a>
              </li>
              <li>
                <a href="/Services">ISO Certification</a>
              </li>
              <li>
                <a href="/iso-9001-training-courses">ISO Training Courses</a>
              </li>
              <li>
                <a href="/BlogLanding">Blogs</a>
              </li>
              <li>
                <a href="/Contact">Contact Us</a>
              </li>
            </ul>
          </div>
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h2 className="h5 pb-2"> </h2>
            <ul>
              <li>
                <a href="/iso-9001-qms">ISO 9001 QMS</a>
              </li>
              <li>
                <a href="/iso-14001-ems">ISO 14001 EMS</a>
              </li>
              <li>
                <a href="/ohsas-18001">OHSAS 18001</a>
              </li>
              <li>
                <a href="/iso-22000">ISO 22000</a>
              </li>
              <li>
                <a href="/iso-27001">ISO 27001</a>
              </li>
              <li>
                <a href="/bs-en-16001">BS / EN 16001</a>
              </li>
              <li>
                <a href="/integrated-iso-system">Integrated ISO System</a>
              </li>
              <li>
                <a href="/online-iso-training">Online ISO Training</a>
              </li>
              <li>
                <a href="/iso9001consultantsindia">ISO 9001 consultants</a>
              </li>
            </ul>
          </div>
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h2 className="h5 pb-2"> </h2>
            <ul>
              <li>
                <a href="/iso-14001-certificate">ISO 14001 Certificate</a>
              </li>
              <li>
                <a href="/ohsas-18001-certificate">OHSAS 18001 Certificate</a>
              </li>
              <li>
                <a href="/haccp-iso-22000-certificate">
                  HACCP ISO 22000 Certificate
                </a>
              </li>
              <li>
                <a href="/iso-certificate-usa">ISO Certificate USA</a>
              </li>
              <li>
                <a href="/isocertificatekuwait">ISO Certificate Kuwait</a>
              </li>
              <li>
                <a href="/isocertificateafrica">ISO Certificate Africa</a>
              </li>
            </ul>
          </div>
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h2 className="h5 pb-2"> </h2>
            <ul>
              <li>
                <a href="/iso9001consultantsindia">ISO Consultants India</a>
              </li>
              <li>
                <a href="/iso9001consultantsdubai">ISO Consultants Dubai</a>
              </li>
              <li>
                <a href="/isoconsultantsusa">ISO Consultants USA</a>
              </li>
              <li>
                <a href="/iso-certificate-usa">ISO Certificate USA</a>
              </li>
              <li>
                <a href="/isocertificateafrica">ISO Certificate Africa</a>
              </li>
              <li>
                <a href="/iso9001consultantskuwait">ISO Consultants Kuwait</a>
              </li>
              <li>
                <a href="/isoconsultantsafrica">ISO Consultants Africa</a>
              </li>
            </ul>
          </div>
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h2 className="h5 pb-2"> </h2>
            <ul>
              <li>
                <a href="/manufacturing-detroit">Manufacturing Detroit</a>
              </li>
              <li>
                <a href="/manufacturing-cleveland">Manufacturing Cleveland</a>
              </li>
              <li>
                <a href="/manufacturing-houston">Manufacturing Houston</a>
              </li>
              <li>
                <a href="/manufacturing-los-angeles">
                  Manufacturing Los Angeles
                </a>
              </li>
              <li>
                <a href="/it-silicon-valley">IT Silicon Valley</a>
              </li>
              <li>
                <a href="/healthcare-boston">Healthcare Boston</a>
              </li>
              <li>
                <a href="/food-chicago">Food Chicago</a>
              </li>
              <li>
                <a href="/construction-houston">Construction Houston</a>
              </li>
              <li>
                <a href="/professional-nyc">Professional NYC</a>
              </li>
            </ul>
          </div>
          <div className="links-section col-12 col-md-6 col-lg-2">
            <h2 className="h5 pb-2">Blogs</h2>
            <ul>
              <li>
                <a
                  href="/dont-get-tricked-by-fake-iso-certificates"
                  onClick={(event) => {
                    event.preventDefault();
                    handleFooterNavigation(
                      "/dont-get-tricked-by-fake-iso-certificates",
                    );
                  }}
                >
                  Don't Get Tricked by Fake ISO Certificates!
                </a>
              </li>
              <li>
                <a
                  href="/what-is-the-actual-process-of-getting-an-iso-certification"
                  onClick={(event) => {
                    event.preventDefault();
                    handleFooterNavigation(
                      "/what-is-the-actual-process-of-getting-an-iso-certification",
                    );
                  }}
                >
                  What is the actual process of getting an iso ?
                </a>
              </li>
              <li>
                <a
                  href="/how-to-select-suitable-iso-standard-for-your-organization"
                  onClick={(event) => {
                    event.preventDefault();
                    handleFooterNavigation(
                      "/how-to-select-suitable-iso-standard-for-your-organization",
                    );
                  }}
                >
                  How to select suitable ISO standard for your organization
                </a>
              </li>
              <li>
                <a
                  href="/understanding-iso-certification-meaning-and-cost"
                  onClick={(event) => {
                    event.preventDefault();
                    handleFooterNavigation(
                      "/understanding-iso-certification-meaning-and-cost",
                    );
                  }}
                >
                  Understanding ISO Certification: Meaning and Cost
                </a>
              </li>
              <li>
                <a
                  href="/iso-27001-2022-annex-a-control-updates"
                  onClick={(event) => {
                    event.preventDefault();
                    handleFooterNavigation(
                      "/iso-27001-2022-annex-a-control-updates",
                    );
                  }}
                >
                  ISO 27001:2022 Annex A Control Updates
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
